import { FinancialBrand } from "@dreambigger/shared/src/types";
import animations from "@dreambigger/shared/src/components/board/styles/animations.module.scss";
import styles from "./StepContentSectionV2.module.scss";
import { StepContentLogoProgress, StepContentHeader } from "./index";

interface StepContentWrapperProps {
  brand: FinancialBrand;
  title: string;
  description: string;
  stepProgress: number;
  previousSlug?: string;
  hideProgressBar?: boolean;
  handleClick: () => void;
  trackAnalytics: () => void;
  children: any;
}

const StepContentWrapper = ({
  brand,
  title,
  description,
  stepProgress,
  previousSlug,
  hideProgressBar,
  handleClick,
  trackAnalytics,
  children,
}: StepContentWrapperProps) => {
  return (
    <>
      <StepContentLogoProgress
        brand={brand}
        stepProgress={stepProgress}
        previousSlug={previousSlug}
        hideProgressBar={hideProgressBar}
        handleClick={handleClick}
        trackAnalytics={trackAnalytics}
      />

      <StepContentHeader
        brand={brand}
        title={title}
        description={description}
      />

      {/* Children (form content) */}
      <div className={`${styles.content} lg_mt-8 ${animations.fadeIn_xs}`}>
        {children}
      </div>
    </>
  );
};

export default StepContentWrapper;
